import { Toast } from 'react-hot-toast';

// custom options for `toast` function
export interface ToastOptions {
  label: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  toastType?: ToastTypes;
  startPause?: () => void;
  endPause?: () => void;
  triggerFocus?: boolean;
  id: string;
  subtext?: string | JSX.Element;
}

export enum ToastTypes {
  Success = 'Success',
  Error = 'Error',
  Info = 'Info',
}

export interface StyledProps {
  type?: ToastTypes;
  visible?: boolean;
}

export interface ToastElementProps extends ToastOptions, Toast {
  triggerFocus?: boolean;
}
